// Mock data para VIBE LOG

export const mockServices = [
  {
    id: 1,
    title: 'Entregas Urbanas',
    description: 'Entregas rápidas e seguras dentro da cidade com rastreamento em tempo real.',
    icon: 'truck'
  },
  {
    id: 2,
    title: 'Transporte Rodoviário',
    description: 'Fretes interestaduais com cobertura nacional e prazos garantidos.',
    icon: 'map'
  },
  {
    id: 3,
    title: 'Cargas Sensíveis',
    description: 'Transporte especializado para cargas refrigeradas e produtos delicados.',
    icon: 'snowflake'
  },
  {
    id: 4,
    title: 'Fretes Expressos',
    description: 'Entregas urgentes com prioridade máxima e agilidade garantida.',
    icon: 'zap'
  },
  {
    id: 5,
    title: 'Rastreamento Real',
    description: 'Acompanhe sua carga 24/7 pelo celular com precisão e segurança.',
    icon: 'map-pin'
  },
  {
    id: 6,
    title: 'Logística Completa',
    description: 'Soluções integradas de armazenagem, transporte e distribuição.',
    icon: 'package'
  }
];

export const mockTips = [
  {
    id: 1,
    title: 'Como embalar corretamente sua carga',
    description: 'Use materiais resistentes como caixas de papelão reforçado. Proteja itens frágeis com plástico bolha e preencha espaços vazios para evitar movimento interno.',
    category: 'Embalagem'
  },
  {
    id: 2,
    title: 'Evite avarias no transporte',
    description: 'Identifique a carga com etiquetas claras. Sinalize produtos frágeis e empilhe corretamente respeitando o peso máximo por camada.',
    category: 'Segurança'
  },
  {
    id: 3,
    title: 'Como calcular o frete ideal',
    description: 'Considere peso, dimensões, distância e urgência. Fretes consolidados custam menos, enquanto expressos garantem rapidez.',
    category: 'Economia'
  },
  {
    id: 4,
    title: 'Frete dedicado vs compartilhado',
    description: 'Dedicado: veículo exclusivo, ideal para grandes volumes. Compartilhado: divide custos com outras cargas, perfeito para volumes menores.',
    category: 'Planejamento'
  },
  {
    id: 5,
    title: 'Transporte de máquinas e equipamentos',
    description: 'Realize inspeção prévia, tire fotos, drene fluidos, proteja partes móveis e use carreta adequada ao peso e dimensões.',
    category: 'Especializado'
  },
  {
    id: 6,
    title: 'Documentação necessária',
    description: 'Mantenha em dia: nota fiscal, conhecimento de transporte (CT-e), certificado de vistoria e seguro de carga quando aplicável.',
    category: 'Documentos'
  }
];

export const mockDifferentials = [
  {
    id: 1,
    title: 'Atendimento Via WhatsApp',
    description: 'Resposta rápida e atendimento personalizado direto no seu celular',
    icon: 'message-circle'
  },
  {
    id: 2,
    title: 'Rastreamento 24/7',
    description: 'Acompanhe sua carga em tempo real de qualquer lugar',
    icon: 'radio'
  },
  {
    id: 3,
    title: 'Motoristas Próprios',
    description: 'Equipe qualificada e treinada para garantir segurança máxima',
    icon: 'shield-check'
  },
  {
    id: 4,
    title: 'Pontualidade Garantida',
    description: 'Cumprimos prazos com rigor e comunicamos qualquer imprevisto',
    icon: 'clock'
  },
  {
    id: 5,
    title: 'Seguro Total',
    description: 'Sua carga protegida contra qualquer eventualidade',
    icon: 'shield'
  },
  {
    id: 6,
    title: 'Frota Moderna',
    description: 'Veículos novos equipados com tecnologia de ponta',
    icon: 'truck'
  }
];

export const mockTrackingOrders = [
  {
    id: 'VL2025001',
    date: '15/01/2025',
    origin: 'São Paulo - SP',
    destination: 'Rio de Janeiro - RJ',
    status: 'Em trânsito',
    progress: 65
  },
  {
    id: 'VL2025002',
    date: '14/01/2025',
    origin: 'Belo Horizonte - MG',
    destination: 'Brasília - DF',
    status: 'Entregue',
    progress: 100
  },
  {
    id: 'VL2025003',
    date: '16/01/2025',
    origin: 'Curitiba - PR',
    destination: 'Florianópolis - SC',
    status: 'Aguardando coleta',
    progress: 10
  }
];

export const mockUser = {
  email: 'cliente@empresa.com',
  password: 'demo123',
  name: 'Cliente Demonstração',
  company: 'Empresa Demo Ltda'
};

export const mockTestimonials = [
  {
    id: 1,
    name: 'Carlos Eduardo Silva',
    company: 'Tech Solutions Ltda',
    role: 'Gerente de Operações',
    rating: 5,
    comment: 'A VIBE LOG transformou nossa logística! O rastreamento em tempo real e o atendimento via WhatsApp facilitaram muito nossa rotina. Entregas sempre no prazo.',
    image: 'https://ui-avatars.com/api/?name=Carlos+Silva&background=0A2540&color=fff&size=128'
  },
  {
    id: 2,
    name: 'Marina Costa',
    company: 'Indústria MC Brasil',
    role: 'Diretora de Logística',
    rating: 5,
    comment: 'Excelente serviço! Transportaram equipamentos sensíveis com total segurança. A equipe é extremamente profissional e o custo-benefício é imbatível.',
    image: 'https://ui-avatars.com/api/?name=Marina+Costa&background=8B3A9C&color=fff&size=128'
  },
  {
    id: 3,
    name: 'Roberto Almeida',
    company: 'Comercial RPA',
    role: 'Proprietário',
    rating: 5,
    comment: 'Trabalho com a VIBE LOG há 2 anos e nunca tive problemas. Pontualidade, comunicação clara e motoristas muito cuidadosos. Recomendo de olhos fechados!',
    image: 'https://ui-avatars.com/api/?name=Roberto+Almeida&background=F4D03F&color=0A2540&size=128'
  },
  {
    id: 4,
    name: 'Juliana Mendes',
    company: 'E-commerce FastShop',
    role: 'Coordenadora de Entregas',
    rating: 5,
    comment: 'Precisávamos de uma transportadora confiável para nosso e-commerce. A VIBE LOG superou expectativas! Sistema de rastreio impecável e suporte sempre disponível.',
    image: 'https://ui-avatars.com/api/?name=Juliana+Mendes&background=0A2540&color=fff&size=128'
  },
  {
    id: 5,
    name: 'Fernando Oliveira',
    company: 'Construtora Horizonte',
    role: 'Engenheiro Civil',
    rating: 5,
    comment: 'Transportaram máquinas pesadas para nossa obra com total segurança. Profissionais qualificados e equipamentos modernos. Parceria de confiança!',
    image: 'https://ui-avatars.com/api/?name=Fernando+Oliveira&background=8B3A9C&color=fff&size=128'
  },
  {
    id: 6,
    name: 'Patrícia Santos',
    company: 'Farmácia Vida Saudável',
    role: 'Gerente',
    rating: 5,
    comment: 'Para produtos farmacêuticos que precisam de temperatura controlada, a VIBE LOG é perfeita. Nunca perdemos nenhuma carga e o atendimento é humanizado.',
    image: 'https://ui-avatars.com/api/?name=Patricia+Santos&background=F4D03F&color=0A2540&size=128'
  }
];

export const whatsappNumber = '5511966355646';
export const whatsappLink = `https://wa.me/${whatsappNumber}`;
export const companyEmail = 'vibetlog@gmail.com';
export const companyPhone = '(11) 96635-5646';
